import React from 'react';
import { Section } from './Section';
import { CheckCircle2Icon } from 'lucide-react';
import { motion } from 'framer-motion';
const benefits = [{
  title: 'Diagnóstico de Brecha Financiera',
  desc: 'Cuánto te falta hoy para jubilarte con tu sueldo actual.'
}, {
  title: 'Análisis de Eficiencia Fiscal',
  desc: 'Cómo hacer que el SAT subsidie parte de tu ahorro.'
}, {
  title: 'Proyección de Valor Garantizado',
  desc: 'Números exactos de recuperación a 10, 15 o 20 años con el respaldo de Seguros Monterrey.'
}];
export function SessionBenefits() {
  return <Section bg="navy-light" data-id="element-196">
      <div className="max-w-4xl mx-auto" data-id="element-197">
        <h2 className="text-2xl md:text-4xl font-bold mb-6 md:mb-12 text-center" data-id="element-198">
          ¿Qué Obtienes en Tu Sesión?
        </h2>

        <div className="space-y-3 md:space-y-6" data-id="element-199">
          {benefits.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15,
          duration: 0.5
        }} className="flex items-start gap-4 md:gap-6 bg-navy p-4 md:p-8 rounded-xl md:rounded-2xl border border-white/5" data-id="element-200">
              <div className="mt-0.5" data-id="element-201">
                <CheckCircle2Icon className="w-6 h-6 md:w-8 md:h-8 text-gold" data-id="element-202" />
              </div>
              <div data-id="element-203">
                <h3 className="text-lg md:text-xl font-bold text-white mb-1 md:mb-2" data-id="element-204">
                  {item.title}
                </h3>
                <p className="text-gray-light text-sm md:text-lg" data-id="element-205">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </Section>;
}